let $zipCodeInput = $('#zipCodeInput');
let $pollutantBtn = $('.wd-pollutant-data-content-btns div');
let zipCode = '';
let globalEwgUrl = 'https://ewgapi.waterdropfilter.com';
let waterCompanyDataItem = {};
// let globalEwgUrl = "http://127.0.0.1:3001"
$(document).ready(function () {
  function toggleContentAndHeaderColor(displaySecondSection) {
    function setHeaderStyles(color, logoWhiteDisplay, logoColoredDisplay) {
      $('.wd-menu-new-title a, .wd-v2-header-font-color').css('color', color);
      // $('.wd-v2-head-logo-fff').css('display', logoWhiteDisplay);
      // $('.wd-v2-head-logo-00549c').css('display', logoColoredDisplay);
    }

    if (displaySecondSection) {
      $('.wd-page-ewg-content-first').fadeOut(100, function () {
        setHeaderStyles('#fff', 'block', 'none');
        $('.wd-ewg-pollutants-show').fadeIn(100);
      });
    } else {
      $('.wd-ewg-pollutants-show').fadeOut(100, function () {
        setHeaderStyles('#111', 'none', 'block');
        $('.wd-page-ewg-content-first').fadeIn(100);
      });
    }
  }
  function decodeHtmlEntities(str) {
    return $('<textarea/>').html(str).text();
  }

  let urlParams = new URLSearchParams(window.location.search);

  let zipParam = urlParams.get('zip');
  let storedZip = localStorage.getItem('ewgZipCode');

  if (zipParam || storedZip) {
    zipCode = zipParam || storedZip.replace('?zip=', '');
    toggleContentAndHeaderColor(true);
    getWaterCompanyInfo();
    localStorage.removeItem('ewgZipCode');
  } else {
    $('.wd-page-ewg-content-first').css('display', 'block');
  }

  function shareToSocialMedia(platform) {
    let url = window.location.href;
    let encodedUrl = encodeURIComponent(url);
    let shareUrl = '';
    if (platform === 'facebook') {
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    } else if (platform === 'twitter') {
      let pageTitle = encodeURIComponent(document.title);
      shareUrl = `https://twitter.com/intent/tweet?text=${pageTitle}&url=${encodedUrl}`;
    }

    window.open(shareUrl, `${platform}-share-dialog`, 'width=800,height=600');
  }

  $('#shareOnFacebook').click(function () {
    shareToSocialMedia('facebook');
  });
  $('#shareOnTwitter').click(function () {
    shareToSocialMedia('twitter');
  });

  let mask = $('.wd-ewg-mask');
  let html = $('html');

  $('#shareOnPrint').click(function () {
    mask.css('display', 'block');
    html.css('overflow', 'hidden');
    localStorage.setItem('ewgZipCode', '?zip=' + zipCode);
    localStorage.setItem('pollutantData', JSON.stringify(pollutantData));
    localStorage.setItem('waterCompanyData', JSON.stringify(waterCompanyDataItem));
  });

  $('.wd-ewg-mask-conent-close').click(function () {
    mask.css('display', 'none');
    html.css('overflow', 'auto');
    localStorage.removeItem('ewgZipCode');
  });

  $('#shareOnCopy').click(function () {
    let url = window.location.href;
    let tempInput = $('<input>').val(url).appendTo('body').select();
    document.execCommand('copy');
    tempInput.remove();
    $(this).find('span').text('Copied');
    setTimeout(() => {
      $(this).find('span').text('Share');
    }, 3000);
  });

  $('.wd-water-providers-btns').on('click', '#toggleButton', function () {
    let text = $('.wd-water-providers-btns span').text().trim();
    $('.wd-water-providers-btns span').text(text === 'MORE' ? 'LESS' : 'MORE');
    // $(".wd-water-providers-btns-svg").toggleClass("rotate");
    $('.wd-water-company-data-list').toggleClass('open');

    $('.wd-water-providers-btns-svg').css('transform-origin', 'center');

    if (text === 'LESS') {
      $('.wd-water-providers-btns-svg').css('transform', 'rotate(0deg)');
    } else {
      $('.wd-water-providers-btns-svg').css('transform', 'rotate(180deg)');
    }
  });

  $('#BackButton').click(function () {
    let basePageUrl = new URL(window.location.href);
    basePageUrl.search = '';

    if (history.pushState) {
      history.pushState({ path: basePageUrl.toString() }, '', basePageUrl.toString());
    }
    toggleContentAndHeaderColor(false);
  });

  function ajaxRequest(url, data, successCallback) {
    // $(".wd-ewg-loading-icon").css("display","flex")
    $.ajax({
      url: globalEwgUrl + url,
      type: 'GET',
      data: data,
      success: successCallback,
      error: function (error) {},
      complete: function () {
        // $(".wd-ewg-loading-icon").hide()
      },
    });
  }

  function getWaterCompanyInfo() {
    $('.wd-water-company-data-list').empty();

    ajaxRequest('/zip_systems', { zip: zipCode }, function (data) {
      let waterCompanyData = data.systemList;

      if (waterCompanyData) {
        $('.ewpSwiper,#toggleButton').css('display', 'block');
        $('.wd-no-contaminants-found').css('display', 'none');
        updateWaterCompanyInfo(waterCompanyData);
        getPollutionDetails(waterCompanyData[0].PWS);
        waterCompanyDataItem = waterCompanyData[0];
      } else {
        $(
          '.wd-printable-number,.overview-data-all-number,.wd-page-ewg-content-second-content-title, .wd-printable-h6 span, .overview-data-right-top span, .overview-data-right-bottom2 span, .wd-printable-right-bottom2 span,.wd-printable-waterdrop, .overview-data-data span, .wd-printable-data-data span,.overview-data-right-top span, .wd-printable-right-top span,.overview-data-right-bottom1 span, .wd-printable-right-bottom1 span'
        ).text('N/A');

        $('.ewpSwiper,#toggleButton').css('display', 'none');
        $('.wd-no-contaminants-found').css('display', 'block');
      }
    });
  }

  function updateWaterCompanyInfo(waterCompanyData) {
    let firstCompany = waterCompanyData[0] ? waterCompanyData[0] : {};
    $('.wd-page-ewg-content-second-content-title, .wd-printable-h6 span, .overview-data-right-top span').text(
      decodeHtmlEntities(firstCompany.SystemName ? firstCompany.SystemName : 'N/A')
    );
    $('.overview-data-right-bottom2 span, .wd-printable-right-bottom2 span').text(
      firstCompany.PrimSource_fulltext ? firstCompany.PrimSource_fulltext : 'N/A'
    );

    $('.wd-water-company-data-list').empty();

    waterCompanyData.forEach(function (system, index) {
      let $li = $('<li>').text(decodeHtmlEntities(system.SystemName));

      if (index === 0) {
        $li.addClass('active');
      }

      $li.on('click', function () {
        $pollutantBtn.first().addClass('active').siblings().removeClass('active');
        $('.wd-water-company-data-list li').removeClass('active');
        $(this).addClass('active');
        $('.wd-page-ewg-content-second-content-title, .wd-printable-h6 span, .overview-data-right-top span').text(
          decodeHtmlEntities(system.SystemName ? system.SystemName : 'N/A')
        );
        $('.overview-data-right-bottom2 span, .wd-printable-right-bottom2 span').text(
          system.PrimSource_fulltext ? system.PrimSource_fulltext : 'N/A'
        );
        waterCompanyDataItem = system;
        getPollutionDetails(system.PWS);
      });

      $('.wd-water-company-data-list').append($li);
    });

    setTimeout(() => {
      let $ul = $('.wd-water-company-data-list');
      let $lis = $ul.find('li');
      let ulWidth = $ul.width();
      let totalLiWidth = 0;

      $lis.each(function () {
        totalLiWidth += $(this).outerWidth(true);
      });

      let $toggleButton = $('#toggleButton');
      if (totalLiWidth > ulWidth && $(window).width() > 768) {
        $toggleButton.css('display', 'flex');
      } else {
        $toggleButton.hide();
      }
    }, 1000);
  }

  let pollutantData = {};
  function getPollutionDetails(pws) {
    $('.wd-pollutant-data-list').empty();
    $('.wd-printable-exceeds-block').empty();
    $('.wd-printable-others-block').empty();
    ajaxRequest('/information', { pws }, function (data) {
      pollutantData = data.information;

      updatePageInfo(pollutantData);

      changePollutantData(pollutantData.exceedsList, 0);

      animateNumber($('.overview-data-all-number'), pollutantData.totalContaminantsCount);

      updateUrlWithZip(zipCode);
    });
    return;
  }
  function updatePageInfo(item) {
    let data = item ? item : {};

    $('.overview-data-right-bottom1 span, .wd-printable-right-bottom1 span').text(
      data.Population.toLocaleString('en-US')
    );

    $('.overview-data-right-top span, .wd-printable-right-top span').text(data.Systemname);

    $('.overview-data-data span, .wd-printable-data-data span').text(data.totalAllCount);
    $('.wd-printable-waterdrop').text(data.waterdropCount);
    $('.wd-printable-number').text(pollutantData.totalContaminantsCount);

    toggleContentAndHeaderColor(true);
  }

  function animateNumber(element, finalNumber) {
    $({ numberValue: parseInt(element.text(), 10) }).animate(
      { numberValue: finalNumber },
      {
        duration: 800,
        easing: 'swing',
        step: function () {
          element.text(Math.ceil(this.numberValue));
        },
        complete: function () {
          element.text(finalNumber);
        },
      }
    );
  }

  function updateUrlWithZip(zipCode) {
    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?zip=' + zipCode;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  $pollutantBtn.click(function () {
    $pollutantBtn.removeClass('active');

    $(this).addClass('active');

    $pollutantBtn.index(this) == 0
      ? changePollutantData(pollutantData.exceedsList, 0)
      : changePollutantData(pollutantData.othersList, 1);
  });

  var myEwgSwiper = new Swiper('.ewpSwiper', {
    slidesPerView: 1,
    spaceBetween: 12,
    grid: {
      rows: 3,
    },
    navigation: {
      nextEl: '.swiper-button-next-ewg',
      prevEl: '.swiper-button-prev-ewg',
    },
    pagination: {
      el: '.swiper-pagination-ewg',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        grid: {
          rows: 2,
        },
        spaceBetween: 24,
      },

      768: {
        slidesPerView: 2,
        grid: {
          rows: 2,
        },
        spaceBetween: 24,
      },
    },
  });

  function changePollutantData(data, dataIndex) {
    let listItemHtml = '';

    $.each(data, function (index, contaminant) {
      let guidelineInfo =
        contaminant.ContaminantHGValue === -1
          ? '<div class="pollutant-guideline-legal">NO EWG HEALTH GUIDELINE</div>'
          : `<div class="pollutant-utility">EWG HEALTH GUIDELINE: <span>${contaminant.ContaminantHGValue} ${contaminant.ContaminantUnits}</span></div>`;
      let legalInfo =
        contaminant.ContaminantMCLValue == -1
          ? `<div class="pollutant-guideline-legal">NO LEGAL LIMIT</div>${
              dataIndex == 0 ? '' : '<div class="pollutant-border"><div></div></div>'
            }`
          : `<div class="pollutant-utility">LEGAL LIMIT: <span>${contaminant.ContaminantMCLValue} ${
              contaminant.ContaminantUnits
            }</span></div>${dataIndex == 0 ? '' : '<div class="pollutant-border"><div></div></div>'}`;

      let averageInfo = `<div class="pollutant-utility">THIS UTILITY: <span>${contaminant.SystemAverage} ${contaminant.ContaminantUnits}</span></div>`;

      listItemHtml += `<li class="swiper-slide">
                                <div class="pollutant-fluoride">Contaminant</div>
                                <div class="pollutant-name">${contaminant.ContaminantName}</div>
                                <div class="pollutant-risk">Health Risk: ${capitalizeFirstWord(
                                  contaminant.ContaminantEffect
                                )}</div>
                                ${
                                  dataIndex === 0
                                    ? `<div class="pollutant-factor">${contaminant.contaminantOverLimitRatio}X</div><div class="pollutant-ewg">EWG Health Guidelines</div><div class="pollutant-border"><div></div></div>`
                                    : ''
                                }
                                ${averageInfo}
                                ${guidelineInfo}
                                ${legalInfo}
                                </li>`;
    });

    $('.wd-pollutant-data-list').html(listItemHtml);

    myEwgSwiper.update();
    myEwgSwiper.slideTo(0, 0);
  }

  function capitalizeFirstWord(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  function checkDataLength(data) {
    return data.length === 5;
  }

  $zipCodeInput.on({
    focus: function () {
      $(this).css('border', '1px solid #00549C');
      $(this).siblings('.wd-page-ewg-content-top-input-warning').css('opacity', '0');
    },
    blur: function () {
      if ($(this).val().length === 0) {
        $(this).css('border', '1px solid #999');
      }
    },
    input: function () {
      var value = $(this).val();
      updateZipCodeInputStyle(checkDataLength(value));
      zipCode = checkDataLength(value) ? value : '';
    },
  });

  $zipCodeInput.on('keydown', function (e) {
    if (e.key === 'Enter' && checkDataLength($(this).val())) {
      e.preventDefault();
      getWaterCompanyInfo();
    }
  });

  $('#seachData').click(function () {
    getWaterCompanyInfo();
  });

  function updateZipCodeInputStyle(isValid) {
    if (isValid) {
      $zipCodeInput.css('border', '1px solid #00549C');
      $zipCodeInput.siblings('svg').css('cursor', 'pointer');
      $zipCodeInput.siblings('.wd-page-ewg-content-top-input-warning').css('opacity', '0');
    } else {
      $zipCodeInput.css('border', '1px solid #BF2D2D');
      $zipCodeInput.siblings('.wd-page-ewg-content-top-input-warning').css('opacity', '1');
    }
  }
});

var productSwiper = new Swiper('.productSwiper', {
  slidesPerView: 1,
  grid: {
    rows: 3,
  },
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-button-next-product',
    prevEl: '.swiper-button-prev-product',
  },
  pagination: {
    el: '.swiper-pagination-product',
    clickable: true,
  },
  // Breakpoints
  breakpoints: {
    0: {
      slidesPerView: 1,
      grid: {
        rows: 3,
      },
      spaceBetween: 12,
    },
    768: {
      slidesPerView: 3,
      grid: {
        rows: 1,
      },
      spaceBetween: 24,
    },
  },
});

var blogSwiper = new Swiper('.wd-swiper2', {
  roundLengths: true,
  autoHeight: true,
  spaceBetween: 15,
  clickable: true,
  pagination: {
    el: '.wd-swiper-pagination2',
  },
});
